// frontend/js/config/aos-config.js
// ------------------------------------------------------------
// Specialized AOS configuration for accordion components
// Optimized timing and easing for professional animations
// ------------------------------------------------------------

export const accordionAnimationConfig = {
  // Base AOS settings optimized for accordions
  duration: 600,
  easing: 'ease-out-cubic',
  once: true,
  mirror: false,
  anchorPlacement: 'top-bottom',
  
  // Accordion-specific settings
  accordion: {
    staggerDelay: 150,        // Delay between accordion items
    baseDelay: 200,           // Base delay for first item
    expandDuration: 400,      // Accordion expand/collapse duration
    contentFadeDelay: 100,    // Content fade-in delay after expand
  },
  
  // Animation variants for different contexts
  variants: {
    hero: {
      duration: 800,
      delay: 400,
      easing: 'ease-out-quart'
    },
    
    section: {
      duration: 600,
      delay: 200,
      easing: 'ease-out-cubic'
    },
    
    interactive: {
      duration: 400,
      delay: 0,
      easing: 'ease-out-back'
    }
  },
  
  // Responsive breakpoints
  responsive: {
    mobile: {
      duration: 400,
      disable: 'phone'  // Disable complex animations on phones
    },
    
    tablet: {
      duration: 500
    },
    
    desktop: {
      duration: 600
    }
  }
};

// Easing function definitions for better animation curves
export const customEasings = {
  'ease-out-cubic': 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  'ease-out-quart': 'cubic-bezier(0.165, 0.84, 0.44, 1)',
  'ease-out-back': 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  'ease-in-out-circ': 'cubic-bezier(0.785, 0.135, 0.15, 0.86)'
};

// Generate staggered delays for accordion items
export function generateStaggeredDelays(itemCount, config = accordionAnimationConfig.accordion) {
  const delays = [];
  for (let i = 0; i < itemCount; i++) {
    delays.push(config.baseDelay + (i * config.staggerDelay));
  }
  return delays;
}

// Responsive animation settings based on device
export function getResponsiveConfig() {
  const width = window.innerWidth;
  
  if (width <= 576) {
    return accordionAnimationConfig.responsive.mobile;
  } else if (width <= 992) {
    return accordionAnimationConfig.responsive.tablet;
  } else {
    return accordionAnimationConfig.responsive.desktop;
  }
}

// Performance-optimized animation detection
export function shouldUseReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
